import { render } from "./DesktopMobile.vue?vue&type=template&id=52bf37a6&scoped=true"
import script from "./DesktopMobile.vue?vue&type=script&lang=js"
export * from "./DesktopMobile.vue?vue&type=script&lang=js"

import "./DesktopMobile.vue?vue&type=style&index=0&id=52bf37a6&lang=less&scoped=true"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bf37a6"]])

export default __exports__